export default __webpack_public_path__ + "fcc37e727add830b2b0b42efd6d20544.png";